@if(!device()) {
<av-loading-item [icon]="'devices_other'" [textKey]="'shared.general.labels.loading'" />
}
@else {
<div class="layout">
    <av-breadcrumb />
    @if (userHasDeviceActions()) {
    <app-device-actions />
    }
    <div class="device-content">
        <router-outlet></router-outlet>
    </div>
</div>
}